// Richard Chan Orthodontics (WA) - three online-bookable offices: Bothell, Mill
// Creek, Monroe. (The Juneau + Sitka AK offices are not online-bookable.) Backend:
// bondLocations.ts CHAN_BOTHELL / _MILL_CREEK / _MONROE (brandId "richard_chan",
// catalog aa8387c3, Edge loc 4/5/6, procedure 245, DB 325). Native booking via
// ortho2-newpatient backend (WCF intake disabled). English-only.
import type { BrandConfig } from "./types";

export const richardChan: BrandConfig = {
  slug: "richard-chan",
  brandId: "richard_chan",
  brandName: "Richard Chan Orthodontics",
  logo: "https://edgestorage.ortho2.com/logos/082297d6-7a8f-4f2e-a89a-2198208fb50b.png",
  phone: "(425) 485-9332",
  phoneHref: "tel:+14254859332",
  theme: { primary: "#002B54", primaryDark: "#001A33" }, // scoured 2026-07-20 chansmiles.com (navy; cyan accent)
  locales: ["en"],
  locations: {
    CHAN_BOTHELL: {
      id: "CHAN_BOTHELL",
      name: "Bothell",
      addressLines: ["19020 Bothell Way NE, Suite A", "Bothell, WA 98011"],
      mapsUrl: "https://maps.google.com/?q=19020+Bothell+Way+NE+Suite+A+Bothell+WA+98011",
      timezone: "America/Los_Angeles",
    },
    CHAN_MILL_CREEK: {
      id: "CHAN_MILL_CREEK",
      name: "Mill Creek",
      addressLines: ["3414 132nd St SE, #301", "Mill Creek, WA 98012"],
      mapsUrl: "https://maps.google.com/?q=3414+132nd+St+SE+301+Mill+Creek+WA+98012",
      timezone: "America/Los_Angeles",
    },
    CHAN_MONROE: {
      id: "CHAN_MONROE",
      name: "Monroe",
      addressLines: ["622 W Main St", "Monroe, WA 98272"],
      mapsUrl: "https://maps.google.com/?q=622+W+Main+St+Monroe+WA+98272",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: {
    BOTHELL: "CHAN_BOTHELL",
    MILL_CREEK: "CHAN_MILL_CREEK",
    MONROE: "CHAN_MONROE",
  },
};
